<h2 mat-dialog-title>{{ inputData.title }}</h2>
<mat-dialog-content [formGroup]="profilForm">


  <mat-form-field appearance="outline">
    <mat-label>Nom</mat-label>
    <input
      matInput
      type="text"
      formControlName="name"
      placeholder="Entrez le nom du profil">
    @if (profilForm.get('name')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
  </mat-form-field>


</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton mat-dialog-close cdkFocusInitial class="bg-mat-red" (click)="resetForm()">Fermer</button>
  @if (inputData.update) {
    <button mat-button class="bg-mat-cyan" [disabled]="profilForm.invalid" (click)="onUpdate()">Modifier</button>
  }@else {
    <button mat-button class="bg-mat-green" [disabled]="profilForm.invalid" (click)="onAdd()">Enregistrer</button>
  }
</mat-dialog-actions>
